import React from 'react';
import { QFlex, QStack } from '@qualio/ui-components';

export const EventFormViewDetailsWrapper: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <QFlex data-cy="form-view-details-section" justifyContent="center" alignItems="center">
      <QStack direction="column" spacing="30px" width="640px">
        {children}
      </QStack>
    </QFlex>
  );
};
